// extracted by mini-css-extract-plugin
module.exports = {"notesList":"_3iExbu","note":"_1lbtkk","shine-lines":"_2nBZtY"};